// ファーム設定のリーグ別永続化（§8）。localStorage に farmsets:<league> で分割保存。
import type { FarmSet } from './schema';

const PREFIX = 'poe2farm';
const ACTIVE_LEAGUE_KEY = `${PREFIX}:active-league`;

function setsKey(league: string): string {
  return `${PREFIX}:farmsets:${league}`;
}

function nowMs(): number {
  return Date.now();
}

export function newId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `id-${Math.random().toString(36).slice(2)}${nowMs().toString(36)}`;
}

function clone<T>(v: T): T {
  return JSON.parse(JSON.stringify(v)) as T;
}

/** 指定リーグの全セット。 */
export function loadSets(league: string): FarmSet[] {
  const raw = localStorage.getItem(setsKey(league));
  if (!raw) return [];
  try {
    const v: unknown = JSON.parse(raw);
    return Array.isArray(v) ? (v as FarmSet[]) : [];
  } catch {
    return [];
  }
}

function writeSets(league: string, sets: FarmSet[]): void {
  localStorage.setItem(setsKey(league), JSON.stringify(sets));
}

/** セットを所属リーグのバケットに upsert（updatedAt を更新）。 */
export function saveSet(set: FarmSet): FarmSet {
  const stored: FarmSet = { ...set, updatedAt: nowMs() };
  const sets = loadSets(set.league);
  const idx = sets.findIndex((s) => s.id === set.id);
  if (idx >= 0) sets[idx] = stored;
  else sets.push(stored);
  writeSets(set.league, sets);
  return stored;
}

export function deleteSet(league: string, id: string): void {
  writeSets(
    league,
    loadSets(league).filter((s) => s.id !== id),
  );
}

export function duplicateSet(league: string, id: string): FarmSet | null {
  const sets = loadSets(league);
  const src = sets.find((s) => s.id === id);
  if (!src) return null;
  const copy: FarmSet = { ...clone(src), id: newId(), name: `${src.name} のコピー`, updatedAt: nowMs() };
  sets.push(copy);
  writeSets(league, sets);
  return copy;
}

export function getActiveLeague(): string | null {
  return localStorage.getItem(ACTIVE_LEAGUE_KEY);
}

export function setActiveLeague(league: string): void {
  localStorage.setItem(ACTIVE_LEAGUE_KEY, league);
}
